interface TrackingIdRecord {
  expiryDate: number;
  value: string;
}

export enum TrackingIdRecords {
  gclid = 'gclid',
  fbclid = 'fbclid',
  msclkid = 'msclkid',
  gbraid = 'gbraid',
  wbraid = 'wbraid',
  ttclid = 'ttclid',
  awc = 'awc',
  s_id = 's_id',
  qclid = 'qclid'
}

export enum TrackingIdRecordsMetaDataName {
  gclid = 'google_click_id',
  fbclid = 'facebook_click_id',
  msclkid = 'microsoft_click_id',
  gbraid = 'google_braid_id',
  wbraid = 'web_braid_id',
  ttclid = 'tiktok_click_id',
  awc = 'awin_click_id',
  s_id = 'financeads_click_id',
  qclid = 'quora_click_id'
}

export const trackingIdRecordsServiceId = {
  [TrackingIdRecords.gclid]: 'S1_9Vsuj-Q',
  [TrackingIdRecords.fbclid]: 'J05PmJuvt36qTe',
  [TrackingIdRecords.msclkid]: 'BkeKqEjuoZQ',
  [TrackingIdRecords.gbraid]: 'S1_9Vsuj-Q',
  [TrackingIdRecords.wbraid]: 'S1_9Vsuj-Q',
  [TrackingIdRecords.ttclid]: '6-qobRfu',
  [TrackingIdRecords.awc]: 'SyfKc4oOjWQ',
  [TrackingIdRecords.s_id]: 'HyiV94juoW7',
  [TrackingIdRecords.qclid]: '7AevQBoe'
};

const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

const getExpiryRecord = (value: string): TrackingIdRecord => {
  const expiryDate = new Date().getTime() + expiryPeriod;

  return {
    value,
    expiryDate
  };
};

export const setTrackingIdRecord = (idRecord: TrackingIdRecords, idRecordParam: string): void => {
  if (!idRecordParam) {
    return;
  }

  // localStorage access throws a SecurityError in partitioned/blocked storage contexts
  // (e.g. Safari private mode, storage-restricted iframes) - tracking is best-effort here.
  try {
    localStorage.setItem(idRecord, JSON.stringify(getExpiryRecord(idRecordParam)));
  } catch {
    // storage blocked, nothing to do
  }
};

export const getTrackingIdRecord = (idRecord: TrackingIdRecords): string | undefined => {
  try {
    const localStorageEntry = localStorage.getItem(idRecord);
    if (!localStorageEntry) {
      return;
    }
    const trackingIdValue: TrackingIdRecord = JSON.parse(localStorageEntry);
    return trackingIdValue.value;
  } catch {
    return;
  }
};
